import PropTypes from 'prop-types'
import React from 'react'

import apiWrapper from 'Helpers/apiWrapper'

import { withAppState } from './AppStateProvider'

export const endpoints = ((baseURL) => {
  return {
    oauthAdminCustomerToken: `${baseURL}/oauth/admin/customer/token`,
    oauthAppToken: `${baseURL}/oauth/app/token`,
    oauthCustomerToken: `${baseURL}/oauth/customer/token`,
    getAccounts: `${baseURL}/api/accounts`,
  }
})(process.env.ACCOUNTS_API_URL)

const ApiContext = React.createContext()

export const withApi = (ComponentToWrap) => {
  const WrappedComponent = (props) => {
    return (
      <ApiContext.Consumer>
        {(apiContext) => (
          <ComponentToWrap {...props} apiWrapper={apiContext.apiWrapper} />
        )}
      </ApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withApi(${
    ComponentToWrap.displayName || ComponentToWrap.name
  })`
  return WrappedComponent
}

const ApiProviderComponent = (props) => {
  const { children } = props

  const apiContext = {
    apiWrapper,
  }

  return (
    <ApiContext.Provider value={apiContext}>{children}</ApiContext.Provider>
  )
}

ApiProviderComponent.defaultProps = {
  children: null,
}

ApiProviderComponent.propTypes = {
  children: PropTypes.node,
  storeGet: PropTypes.func.isRequired,
  storeSet: PropTypes.func.isRequired,
}

export const ApiProvider = withAppState(ApiProviderComponent)

export const extractData = ({ data }) => data
